import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import './BreadCrumbs.scss';

@Component
export class BreadCrumbs extends ThemeComponent {

}
